(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aufguss-blackweek"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ── Countdown ── */
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    document.querySelectorAll('[data-ar-blackweek-timer]').forEach(function (timer) {
      var section = timer.closest('[data-ar-blackweek]');
      var target = new Date(timer.getAttribute('data-target')).getTime();
      if (isNaN(target)) return;
      var dEl = timer.querySelector('[data-days]');
      var hEl = timer.querySelector('[data-hours]');
      var mEl = timer.querySelector('[data-minutes]');
      var sEl = timer.querySelector('[data-seconds]');
      var expiredEl = section ? section.querySelector('[data-ar-blackweek-expired]') : null;

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (dEl) dEl.textContent = '00';
          if (hEl) hEl.textContent = '00';
          if (mEl) mEl.textContent = '00';
          if (sEl) sEl.textContent = '00';
          if (expiredEl) {
            expiredEl.hidden = false;
            timer.style.display = 'none';
          }
          clearInterval(handle);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff / 3600000) % 24);
        var m = Math.floor((diff / 60000) % 60);
        var s = Math.floor((diff / 1000) % 60);
        if (dEl) dEl.textContent = pad(d);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
      tick();
      var handle = setInterval(tick, 1000);
    });

    /* ── Click-to-Copy Discount Code ── */
    document.querySelectorAll('[data-ar-blackweek-code]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        var done = function () {
          btn.classList.add('is-copied');
          setTimeout(function () { btn.classList.remove('is-copied'); }, 1200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () {
            // Fallback: legacy execCommand
            var ta = document.createElement('textarea');
            ta.value = code;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); done(); } catch (e) {}
            document.body.removeChild(ta);
          });
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(ta);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aufguss-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Lazy-init carousel logic: nur wenn der Slider sichtbar ist
       (spart First-Input-Delay & Main-Thread auf Seiten mit Slidern, die
        außerhalb des Viewports sind). */
    function initSlider(grid) {
      if (grid.__arInited) return;
      grid.__arInited = true;
      var section = grid.closest('section');
      if (!section) return;
      var prev = section.querySelector('[data-ar-prev]');
      var next = section.querySelector('[data-ar-next]');
      var dotsHost = section.querySelector('[data-ar-products-dots]');

      var cards = function () { return grid.querySelectorAll('.ar-product'); };
      var cardWidth = function () {
        var first = grid.querySelector('.ar-product');
        if (!first) return Math.max(280, grid.clientWidth * 0.7);
        return first.getBoundingClientRect().width + 24; /* 24 = grid gap */
      };
      var visibleCount = function () {
        var w = cardWidth();
        if (!w) return 1;
        return Math.max(1, Math.round(grid.clientWidth / w));
      };
      var pageCount = function () {
        var total = cards().length;
        var visible = visibleCount();
        return Math.max(1, total - visible + 1);
      };

      function maxScroll() {
        return Math.max(0, grid.scrollWidth - grid.clientWidth);
      }
      function nearLeft() { return grid.scrollLeft <= 2; }
      function nearRight() { return grid.scrollLeft >= maxScroll() - 2; }

      if (prev) prev.addEventListener('click', function () {
        if (nearLeft()) {
          // jump to end
          grid.scrollTo({ left: maxScroll(), behavior: 'smooth' });
        } else {
          grid.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
        }
      });
      if (next) next.addEventListener('click', function () {
        if (nearRight()) {
          // jump back to start
          grid.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          grid.scrollBy({ left: cardWidth(), behavior: 'smooth' });
        }
      });

      function buildDots() {
        if (!dotsHost) return;
        var n = pageCount();
        if (n <= 1) { dotsHost.innerHTML = ''; dotsHost.style.display = 'none'; return; }
        dotsHost.style.display = '';
        var html = '';
        for (var i = 0; i < n; i++) {
          html += '<span data-ar-dot="' + i + '" role="tab" aria-label="Position ' + (i + 1) + '"></span>';
        }
        dotsHost.innerHTML = html;
        dotsHost.querySelectorAll('[data-ar-dot]').forEach(function (dot) {
          dot.addEventListener('click', function () {
            var idx = parseInt(dot.getAttribute('data-ar-dot'), 10) || 0;
            grid.scrollTo({ left: idx * cardWidth(), behavior: 'smooth' });
          });
        });
        updateActiveDot();
      }

      function updateActiveDot() {
        if (!dotsHost) return;
        var idx = Math.round(grid.scrollLeft / cardWidth());
        var dots = dotsHost.querySelectorAll('[data-ar-dot]');
        if (idx >= dots.length) idx = dots.length - 1;
        if (idx < 0) idx = 0;
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
        // Slider wrappt — keine disabled-Buttons mehr.
      }

      var scrollTimer;
      grid.addEventListener('scroll', function () {
        if (scrollTimer) cancelAnimationFrame(scrollTimer);
        scrollTimer = requestAnimationFrame(updateActiveDot);
      }, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(buildDots, 150);
      });

      // initial render — wait one frame so layout is settled
      requestAnimationFrame(buildDots);
    }

    var grids = document.querySelectorAll('[data-ar-products-grid]');
    if (!grids.length) return;

    /* IntersectionObserver = init nur wenn Slider in Viewport-Nähe.
       Fallback (alte Browser): direkt initialisieren. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            initSlider(e.target);
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '200px 0px' });
      grids.forEach(function (g) { io.observe(g); });
    } else {
      grids.forEach(initSlider);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
